import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=e9f7f8d8&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"
import style0 from "./Profile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9f7f8d8')) {
      api.createRecord('e9f7f8d8', component.options)
    } else {
      api.reload('e9f7f8d8', component.options)
    }
    module.hot.accept("./Profile.vue?vue&type=template&id=e9f7f8d8&", function () {
      api.rerender('e9f7f8d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Profile.vue"
export default component.exports